import { FC, useEffect, useState } from "react";
import DriverDetailsDriverPlanEntry from "../common/types/driver-details-plan-entry";
import driverDetailsActiveRoutePlansByRailyPlanEntryFactory from "./common/driver-details-active-route-plans-by-raily-plan-entry.factory";
import LoaderComponent from "../../../../../../common/components/loader/loader.component";
import DriverDetailsActiveRoutePlansContentComponent from "../driver-details-active-route-plans-content.component";
import DriverDetailsCandidatureComponent from "../../candidature/driver-details-candidature.component";
import { useAppContext } from "../../../../../../context/app.context";
import UserRole from "../../../../../../common/types/user-role";
import useAbort from "../../../../../../common/hooks/use-abort";
import useDriverPlanList from "../../../../../../common/services/driver/plan/list/use-driver-plan-list";
import DriverPlanList from "../../../../../../common/services/driver/plan/list/driver-plan-list";
import DriverPlanListParams from "../../../../../../common/services/driver/plan/list/driver-plan-list-params";

type DriverDetailsPlanByRailyProps = {
  driverUuid: string;
  isVisible: boolean;
  asCardComponent?: boolean;
};

const DriverDetailsPlanByRailyComponent: FC<DriverDetailsPlanByRailyProps> = (
  props,
) => {
  const { user } = useAppContext();

  const driverPlanList = useDriverPlanList();
  const driverPlanAbort = useAbort();

  const [planEntries, setPlanEntries] = useState<
    DriverDetailsDriverPlanEntry[]
  >([]);

  const onPlanFetchSuccess = (responseData: DriverPlanList) => {
    const planEntries =
      driverDetailsActiveRoutePlansByRailyPlanEntryFactory.createPlanEntries(
        responseData.entries,
        user?.roles.includes(UserRole.ADMIN) ?? false,
      );

    setPlanEntries(planEntries);
  };

  const fetchPlan = () => {
    if (!props.driverUuid) {
      return;
    }

    const params: DriverPlanListParams = {
      driverUuid: props.driverUuid,
    };

    driverPlanList.load(params, driverPlanAbort.signal);
  };

  useEffect(() => {
    if (!driverPlanList.data) {
      return;
    }
    onPlanFetchSuccess(driverPlanList.data);
  }, [driverPlanList.data]);

  useEffect(() => {
    if (!props.isVisible || planEntries.length) {
      return;
    }

    fetchPlan();

    return driverPlanAbort.revoke;
  }, [props.isVisible, props.driverUuid]);

  if (driverPlanList.isLoading && !planEntries.length) {
    return (
      <div className="driver_details_active_route_plans_loader_wrapper">
        <LoaderComponent type="primary" />
      </div>
    );
  }

  return (
    <>
      <DriverDetailsCandidatureComponent
        driverUuid={props.driverUuid}
        isVisible={props.isVisible}
        onAcceptCandidatureSuccess={fetchPlan}
        currentPlanEntries={planEntries}
      />
      <DriverDetailsActiveRoutePlansContentComponent
        driverUuid={props.driverUuid}
        planEntries={planEntries}
        refetchPlan={fetchPlan}
        asCardComponent={props.asCardComponent}
      />
    </>
  );
};

export default DriverDetailsPlanByRailyComponent;
